import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import Products from '../../Models/Products';
import Profile from '../../Models/Profile';
import axios from 'axios';
import SimpleReactValidator from 'simple-react-validator';
import { Header } from '../Common';
import Common from "../../Models/Common";
class IntroductoryText extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('1'))
            this.props.history.push('/login/seller');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        // console.log(logged_user)
        this.state = {
            _id: false,
            productsList: [],
            user: logged_user,
            username: '',
            file: null,
            content: '',
            oldfile: ''
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    }
    onChange(e) {
        this.setState({ file: e.target.files[0] })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    componentDidMount() {
        Products.getProductList(this.state.user.id, 1).then(res => {
            if (res.data.payload != null) {
                this.setState({ productsList: res.data.payload })
            }
        })
        Profile.getPersonal(this.state.user.id).then(res => {
            if (res.data.personal != null) {
                this.setState({ username: res.data.personal.first_name })
                this.setState({ content: res.data.personal.personal_details })
                this.setState({ oldfile: res.data.personal.img })
            }
        })
    }
    handleSubmit(e) {
        document.getElementById("intro_entry").disabled = true;
        e.preventDefault();
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        const formData = new FormData();
        formData.append('username', this.state.username)
        formData.append('file', this.state.file)
        formData.append('personal_content', this.state.content)
        formData.append('user_id', this.state.user.id)
        formData.append('oldfile', this.state.oldfile)
        axios({
            method: 'post',
            // url: 'http://192.168.1.110/sharework_back_v2/public/backend/upload-personal-text',
            url: Common.api + 'upload-personal-text',
            data: formData,
            config: {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
        }).then(
            res => {
                if (res.data.message === "Success") {
                    alert(this.props.t('0'))
                    window.localStorage.setItem('pro_pic', JSON.stringify(res.data.profile_pic))
                    console.log(JSON.stringify(res.data.profile_pic))
                    this.props.history.push('/seller-edit-profile')
                }
            })

    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    {/* <div className="col-md-12 tr_blank_medium mt-5 "></div> */}
                    <div className="container-fluid main">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                    {this.props.t('2')}
                                    </div>
                                <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center", paddingTop: "5%" }} className="container">
                                    {/* <div className="col-md-12" style={{ padding: "1%" }}>&nbsp;</div> */}
                                    <div className="row">
                                        {/* <div className="col-md-1 row"></div> */}
                                        <div className="col-md-2">
                                            <div style={{ textAlign: "left", fontSize: "14px" }}><span>{this.props.t('6')}</span></div>
                                            <div className="mt-1" style={{ textAlign: "right", textAlign: "left" }}><span style={{ fontSize: "10px" }}>{this.props.t('8')}</span></div>
                                        </div>
                                        <div className="col-md-9" style={{ textAlign: "left" }}>
                                            <textarea value={this.state.content} onChange={this.updateValue.bind(this, 'content')}
                                                style={{ border: "1px solid #bdbdbd", borderRadius: "6px", padding: "2%" }}
                                                rows="15"
                                                cols="33"
                                                type="text">
                                            </textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12" style={{ padding: "1%" }}>&nbsp;</div>
                                    <div className="col-md-12" style={{ width: "100%" }}>
                                        <div className="col-md-6" style={{ textAlign: "left", paddingBottom: "3%" }}>
                                            <button onClick={this.handleSubmit.bind(this)} id="intro_entry"
                                                style={{ padding: "2%", borderRadius: "7px", backgroundColor: "#90d47b", color: "white", width: "100%" }}>
                                                {this.props.t('9')}
                                                </button>
                                        </div>
                                        <div className="col-md-6" style={{ textAlign: "left", paddingBottom: "3%" }}>
                                            <Link style={{ color: "#777272" }} to={{
                                                pathname: `/seller-edit-profile`,
                                            }}>
                                                <button style={{ padding: "2%", borderRadius: "7px", color: "green", border: "1px solid green", width: "100%" }}>{this.props.t('4')}</button>
                                            </Link>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mt-5 mb-3 input_name big_font text-left" style={{ width: "100%" }}>
                                            {this.props.t('2')}
                                    </div>

                                        <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center", paddingTop: "5%" }} className="container">
                                            <div className="col-md-12" style={{ padding: "1%" }}>&nbsp;</div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1 row"></div>
                                                <div className="col-md-2">
                                                    <div style={{ textAlign: "left", fontSize: "14px" }}><span>{this.props.t('6')}</span></div>
                                                    <div className="mt-1" style={{ textAlign: "right", textAlign: "left" }}><span style={{ fontSize: "10px" }}>{this.props.t('8')}</span></div>
                                                </div>
                                                <div className="col-md-9 row" style={{ textAlign: "left" }}>
                                                    <div>
                                                        <textarea value={this.state.content} onChange={this.updateValue.bind(this, 'content')}
                                                            style={{ border: "1px solid #bdbdbd", borderRadius: "6px", padding: "2%" }}
                                                            rows="15"
                                                            cols="60"
                                                            type="text">
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12" style={{ padding: "1%" }}>&nbsp;</div>
                                            <div className="col-md-12 row" style={{ width: "100%" }}>
                                                <div className="col-md-6" style={{ textAlign: "right", borderBottom: "1px solid #e8e3e3", paddingBottom: "3%" }}>
                                                    <button onClick={this.handleSubmit.bind(this)} id="intro_entry"
                                                        style={{ padding: "2%", borderRadius: "7px", backgroundColor: "#90d47b", color: "white", width: "100px" }}>
                                                        {this.props.t('9')}
                                                </button>
                                                </div>
                                                <div className="col-md-6" style={{ textAlign: "left", borderBottom: "1px solid #e8e3e3", paddingBottom: "3%" }}>
                                                    <Link style={{ color: "#777272" }} to={{
                                                        pathname: `/seller-edit-profile`,
                                                    }}>
                                                        <button style={{ padding: "2%", borderRadius: "7px", color: "green", border: "1px solid green", width: "100px" }}>{this.props.t('4')}</button>
                                                    </Link>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { IntroductoryText }


 IntroductoryText = withTranslation('src_Components_Profile_IntroductoryText')(IntroductoryText);
